import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  input: {
    backgroundColor: theme.palette.background100,
    borderRadius: "12px",

    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      "& fieldset": {
        borderColor: theme.palette.neutral300,
      },
    },
    "& .MuiOutlinedInput-input": {
      padding: "10px 16px 10px 16px",
    },
  },
  fadeIn: {
    animation: `$slideIn 0.5s forwards`,
  },
  fadeOut: {
    animation: `$slideOut 0.5s forwards`,
  },
  "@keyframes slideIn": {
    from: { transform: "translateX(100%)", opacity: 0 },
    to: { transform: "translateX(0)", opacity: 1 },
  },
  "@keyframes slideOut": {
    from: { transform: "translateX(0)", opacity: 1 },
    to: { transform: "translateX(100%)", opacity: 0 },
  },
}))

export default useStyles
